
import controller from './Controller';
import React from 'react';
class Main extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		if (!this.check(this.props.value || "")) {
			return (<div className="cs-shared-richcontent" />);
		}
		return (
			<div className="cs-shared-richcontent" 
			dangerouslySetInnerHTML={{__html: this.props.value }} />
		)
	}
	check(value) {
		return true;
		var l = value.match(/<[^\/>]+>/g) || [];
		var r = value.match(/<\/[^>]+>/g) || [];
		return l.length == r.length;
	}
}
export default Main;


// WEBPACK FOOTER //
// ./src/coms/rich/RichContent.js